/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */

import Variation from './Variation'
import NewVariation from '../../Step05/components/NewVariation'
import NewRateVariation from './NewRateVariation'
import RateVariation from './RateVariation'

/**
 *     Step main container
 */
export default class VariantionContainer extends React.Component<any, any> {
    CreateVariation: any
    constructor(props: any) {
        super(props)
        this.state = {}
        this.reqVariation = this.reqVariation.bind(this)
    }

    componentWillMount() {
        if (this.props.editRenewal) {
            this.props.getRenewalVariation(this.props.quoteId)
        } else {
            this.props.getQuoteVariation(this.props.quoteId)
        }
    }

    componentWillUnmount() {
        this.props.step05.response = null
    }
    reqVariation = () => {
        this.CreateVariation = 'add'
    }

    /**
     * Handle create New Variation click
     */
    createNewVariation = (reqQuote) => {
        this.props.createQuoteVariation(this.props.quoteId)
        // this.variation(req_quote)
        // let step05
        // if (this.props.editRenewal) {
        //     step05 = this.props.renewalStep05
        // } else {
        //     step05 = this.props.step05
        // }
        // let get_last_array = step05.response[step05.response.length - 1]
        this.CreateVariation = reqQuote
        // this.create_variation = () => {
        //     if (req_quote !== '' && req_quote == 'Request_rate') {
        //         return (
        //             <RateVariation
        //                 index={get_last_array}
        //                 values={step05.response[get_last_array]}
        //                 quoteId={this.props.quoteId}
        //                 delQuoteVariation={this.props.delQuoteVariation}
        //                 issueQuoteVariation={this.props.issueQuoteVariation}
        //                 updateQuoteVariation={
        //                     (this.props.editRenewal) ?
        //                         this.props.updateRenewalVariation :
        //                         this.props.updateQuoteVariation
        //                 }
        //                 bindQuoteVariation={this.props.bindQuoteVariation}
        //                 inviteQuoteVariation={this.props.inviteQuoteVariation}
        //                 checkSoftReferral={this.props.checkSoftReferral}
        //                 renewalBindQuoteVariation={this.props.renewalBindQuoteVariation}
        //                 history={this.props.history}
        //                 loading={step05.loading}
        //                 softReferrals={step05.softReferrals}
        //                 dirtySteps={this.props.dirtySteps}
        //                 editRenewal={this.props.editRenewal}
        //             />
        //         )
        //     }
        //     else {
        //         return (
        //             <Variation
        //                 index={get_last_array}
        //                 values={step05.response[get_last_array]}
        //                 quoteId={this.props.quoteId}
        //                 delQuoteVariation={this.props.delQuoteVariation}
        //                 issueQuoteVariation={this.props.issueQuoteVariation}
        //                 updateQuoteVariation={
        //                     (this.props.editRenewal) ?
        //                         this.props.updateRenewalVariation :
        //                         this.props.updateQuoteVariation
        //                 }
        //                 bindQuoteVariation={this.props.bindQuoteVariation}
        //                 inviteQuoteVariation={this.props.inviteQuoteVariation}
        //                 checkSoftReferral={this.props.checkSoftReferral}
        //                 renewalBindQuoteVariation={this.props.renewalBindQuoteVariation}
        //                 history={this.props.history}
        //                 loading={step05.loading}
        //                 softReferrals={step05.softReferrals}
        //                 dirtySteps={this.props.dirtySteps}
        //                 editRenewal={this.props.editRenewal}
        //             />

        //         )
        //     }
        // }
    }
    // createNewRateVariation = (req_quote) => {
    //     this.props.createQuoteVariation(this.props.quoteId)   
    // }

    render() {
        let step05
        if (this.props.editRenewal) {
            step05 = this.props.renewalStep05
        } else {
            step05 = this.props.step05
        }

        this.props.variationsStep05(step05.response)

        return (
            <div className="quote__form__group form__w100 variantion__container">

                {(step05.response && step05.response[0] && step05.response[0].premium !== 0 && step05.done) ?
                    <Variation
                        index={0}
                        values={step05.response[0]}
                        quoteId={this.props.quoteId}
                        delQuoteVariation={this.props.delQuoteVariation}
                        issueQuoteVariation={this.props.issueQuoteVariation}
                        updateQuoteVariation={
                            (this.props.editRenewal) ?
                                this.props.updateRenewalVariation :
                                this.props.updateQuoteVariation
                        }
                        bindQuoteVariation={this.props.bindQuoteVariation}
                        inviteQuoteVariation={this.props.inviteQuoteVariation}
                        checkSoftReferral={this.props.checkSoftReferral}
                        renewalBindQuoteVariation={this.props.renewalBindQuoteVariation}
                        loading={step05.loading}
                        history={this.props.history}
                        softReferrals={step05.softReferrals}
                        dirtySteps={this.props.dirtySteps}
                        editRenewal={this.props.editRenewal}
                        totalCollection={this.props.totalCollection}
                        checkUpdate={this.props.checkUpdate}
                    />
                    : <div>Loading</div>}
                {(step05.response && step05.response[1] && step05.response[1].premium !== 0 && step05.done) ?
                    (this.CreateVariation !== '' && this.CreateVariation === 'Request_rate') ?
                        <RateVariation
                            index={1}
                            values={step05.response[1]}
                            quoteId={this.props.quoteId}
                            delQuoteVariation={this.props.delQuoteVariation}
                            issueQuoteVariation={this.props.issueQuoteVariation}
                            updateQuoteVariation={
                                (this.props.editRenewal) ?
                                    this.props.updateRenewalVariation :
                                    this.props.updateQuoteVariation
                            }
                            bindQuoteVariation={this.props.bindQuoteVariation}
                            inviteQuoteVariation={this.props.inviteQuoteVariation}
                            checkSoftReferral={this.props.checkSoftReferral}
                            renewalBindQuoteVariation={this.props.renewalBindQuoteVariation}
                            history={this.props.history}
                            loading={step05.loading}
                            softReferrals={step05.softReferrals}
                            dirtySteps={this.props.dirtySteps}
                            editRenewal={this.props.editRenewal}
                            reqVariation={this.reqVariation}
                            totalCollection={this.props.totalCollection}
                            checkUpdate={this.props.checkUpdate}
                            editQuotes={this.props.editQuotes}
                        /> : <Variation
                            index={1}
                            values={step05.response[1]}
                            quoteId={this.props.quoteId}
                            delQuoteVariation={this.props.delQuoteVariation}
                            issueQuoteVariation={this.props.issueQuoteVariation}
                            updateQuoteVariation={
                                (this.props.editRenewal) ?
                                    this.props.updateRenewalVariation :
                                    this.props.updateQuoteVariation
                            }
                            bindQuoteVariation={this.props.bindQuoteVariation}
                            inviteQuoteVariation={this.props.inviteQuoteVariation}
                            checkSoftReferral={this.props.checkSoftReferral}
                            renewalBindQuoteVariation={this.props.renewalBindQuoteVariation}
                            history={this.props.history}
                            loading={step05.loading}
                            softReferrals={step05.softReferrals}
                            dirtySteps={this.props.dirtySteps}
                            editRenewal={this.props.editRenewal}
                            totalCollection={this.props.totalCollection}
                            checkUpdate={this.props.checkUpdate}
                        />

                    : null}

                {(step05.response && step05.response[2] && step05.response[2].premium !== 0 && step05.done) ?
                    <Variation
                        index={2}
                        values={step05.response[2]}
                        quoteId={this.props.quoteId}
                        delQuoteVariation={this.props.delQuoteVariation}
                        issueQuoteVariation={this.props.issueQuoteVariation}
                        updateQuoteVariation={
                            (this.props.editRenewal) ?
                                this.props.updateRenewalVariation :
                                this.props.updateQuoteVariation
                        }
                        bindQuoteVariation={this.props.bindQuoteVariation}
                        inviteQuoteVariation={this.props.inviteQuoteVariation}
                        checkSoftReferral={this.props.checkSoftReferral}
                        renewalBindQuoteVariation={this.props.renewalBindQuoteVariation}
                        history={this.props.history}
                        loading={step05.loading}
                        softReferrals={step05.softReferrals}
                        dirtySteps={this.props.dirtySteps}
                        editRenewal={this.props.editRenewal}
                        totalCollection={this.props.totalCollection}
                        checkUpdate={this.props.checkUpdate}
                    />
                    : null}
                {(step05.response && step05.response[3] && step05.response[3].premium !== 0 && step05.done) ?
                    <Variation
                        index={3}
                        values={step05.response[3]}
                        quoteId={this.props.quoteId}
                        delQuoteVariation={this.props.delQuoteVariation}
                        issueQuoteVariation={this.props.issueQuoteVariation}
                        updateQuoteVariation={
                            (this.props.editRenewal) ?
                                this.props.updateRenewalVariation :
                                this.props.updateQuoteVariation
                        }
                        bindQuoteVariation={this.props.bindQuoteVariation}
                        inviteQuoteVariation={this.props.inviteQuoteVariation}
                        checkSoftReferral={this.props.checkSoftReferral}
                        renewalBindQuoteVariation={this.props.renewalBindQuoteVariation}
                        loading={step05.loading}
                        history={this.props.history}
                        softReferrals={step05.softReferrals}
                        dirtySteps={this.props.dirtySteps}
                        editRenewal={this.props.editRenewal}
                        totalCollection={this.props.totalCollection}
                        checkUpdate={this.props.checkUpdate}
                    />
                    : null}
                {/* {this.create_variation} */}

                {(!this.props.editRenewal && this.CreateVariation !== 'Request_rate') ?
                    <NewRateVariation onClick={() => this.createNewVariation('Request_rate')} /> :
                    null
                }

                {(step05.response.length < 3 && !this.props.editRenewal) ?
                    <NewVariation onClick={() => this.createNewVariation('add_quote')} /> :
                    null
                }
            </div>
        )

    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05c/components/VariantionContainer.tsx